import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReduxBanner from '../elements-banner/ReduxBanner';
import { NotificationBanner } from '../elements-banner/notification-banner';

const ManageAddonsBanner = ({ intl }) => {
  return (
    <ReduxBanner>
      <NotificationBanner
        outerBannerClass='fixed-banner'
        bannerId='addonsSaveSuccess'
        timing={2}
        message={
          <div className='flex middle center text-white'>
            <div>
              <i className='ico icon-yes' />
            </div>
            <div className='margin-md-left'>
              <FormattedMessage
                id='web_2.manage_addons_banner.addon_saved'
                defaultMessage='Add-on item saved'
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass='fixed-banner'
        bannerId='addonsEditSuccess'
        timing={2}
        message={
          <div className='flex middle center text-white'>
            <div>
              <i className='ico icon-yes' />
            </div>
            <div className='margin-md-left'>
              <FormattedMessage
                id='web_2.manage_addons_banner.modified'
                defaultMessage='Add-on item modified'
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass='fixed-banner'
        bannerId='addonsDeleteSuccess'
        timing={2}
        message={
          <div className='flex middle center text-white'>
            <div>
              <i className='ico icon-yes' />
            </div>
            <div className='margin-md-left'>
              <FormattedMessage
                id='web_2.manage_addons_banner.deleted'
                defaultMessage='Add-on item deleted'
              />
            </div>
          </div>
        }
      />
      <NotificationBanner
        outerBannerClass='fixed-banner'
        customClass='error-banner'
        timing={2}
        bannerId='addonsDeleteError'
        message={
          <div className='flex middle center text-white'>
            <div>
              <img
                className='ico warning-sign'
                src='/web-2/assets/images/warning-sign.svg?v=rb'
                alt={intl.formatMessage({
                  id: 'web_2.manage_addons_banner.warning_sign',
                  defaultMessage: 'warning sign'
                })}
              />
            </div>
            <div className='margin-md-left'>
              <FormattedMessage
                id='web_2.manage_addons_banner.couldnt_delete'
                defaultMessage='We couldn’t delete at this time. Please try again.'
              />
            </div>
          </div>
        }
      />
    </ReduxBanner>
  );
};

export default injectIntl(ManageAddonsBanner);
